// Configuration for the store
export let STORE_ID = 7;
export const setStoreId = (id) => { STORE_ID = id; };

// Default locale
export const DEFAULT_LOCALE = 'ar';
export const FALLBACK_LOCALE = 'fr';

export const API_BASE_URL = 'https://gestionshoop.shooplinkdz.com/backend/api.php';
